import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloMercado } from "../models/mercado";
import { Repositorio } from "./repositorio";

export class RepositorioMercado extends Repositorio<ModeloMercado> {
  constructor() {
    super(ConstanteGlobal.MERCADO);
  }
}
